/**
 * Build a full API URL from REACT_APP_API and a resource path.
 * REACT_APP_API includes the /api prefix (e.g. https://dev-api.msuite.com/api).
 *
 * @param {string} path - Resource path such as "/auth/sso/resolve-email"
 * @returns {string}
 */
function getApiBase() {
  let base = (process.env.REACT_APP_API || "").replace(/\/$/, "");
  if (!base && process.env.REACT_APP_LOGIN) {
    const login = String(process.env.REACT_APP_LOGIN).replace(/\/$/, "");
    const suffix = "/auth/user";
    if (login.endsWith(suffix)) {
      base = login.slice(0, -suffix.length);
    }
  }
  return base;
}

export function apiUrl(path) {
  let base = getApiBase();
  let normalizedPath = path.startsWith("/") ? path : `/${path}`;

  // Allow legacy paths that still include /api when the base already ends with /api.
  if (base.endsWith("/api") && normalizedPath.startsWith("/api/")) {
    normalizedPath = normalizedPath.slice(4);
  }

  // msuite_api mounts routes under /api — tolerate REACT_APP_API without the /api suffix.
  if (
    base &&
    !base.endsWith("/api") &&
    (normalizedPath.startsWith("/auth/") || normalizedPath.startsWith("/api/"))
  ) {
    if (normalizedPath.startsWith("/api/")) {
      normalizedPath = normalizedPath.slice(4);
    }
    base = `${base}/api`;
  }

  if (!base) {
    throw new Error(
      "REACT_APP_API (or REACT_APP_LOGIN) must be set to call the msuite_api backend"
    );
  }

  return `${base}${normalizedPath}`;
}
